import { withStyles, Grid } from "@material-ui/core";
import React from "react";

const styles = (theme) => ({
  header: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelLabelValueColor,
    lineHeight: "16px",
    fontWeight: 600,
    marginTop: 20,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
  },
});

const Header = ({ classes, label }) => {
  return (
    <Grid item xs={12} className={classes.header}>
      {label}
    </Grid>
  );
};

export default withStyles(styles)(Header);
